import './style.css.js';
import React, { Children, useMemo } from 'react';
import { GroupListItem } from './group-list-item.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const TagGroupWithoutOverflow = /* @__PURE__ */ __name(({
  children
}) => {
  const childArray = Children.toArray(children);
  const wrappedChildren = useMemo(
    () => childArray.map((child) => /* @__PURE__ */ React.createElement(GroupListItem, {
      key: Math.random()
    }, child)),
    [childArray]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, wrappedChildren);
}, "TagGroupWithoutOverflow");

export { TagGroupWithoutOverflow };
//# sourceMappingURL=group.js.map
